// Copyright (c) 2020 Comsearch, Inc., All rights reserved

// finds the modulation scheme label from the stored lookup data
// the output of this will be the same as redux/helpers/makeModulationSchemeLabel
// however that util takes a modulationScheme details entity and concatenates
// the label on its own whereas the concatenation from the stored lookup
// value will happen in the backend.

// These are separate because although the output is expected to be the same, the input will be different depending on the scenario.

const getModulationSchemeLabelFromLookup = modulationSchemeId => (dispatch, getState) => (
  getState().domain.getIn(['radioSettings', 'modulationSchemes'])
    .find(m => m.get('modulationSchemeId') === modulationSchemeId)
    .get('modulationScheme')
)

export default getModulationSchemeLabelFromLookup
